function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { isScdProperty, Property } from 'common/query-builder/query-block/properties-menu/types';
import { Offset } from '../offset';

/**
 * This is for aggregate by SCD property
 * the offset shifts the time series to right by the specified amount
 */
export function SCDOffsetBlock(props: {
  property: Property;
  onChange: (property: Property) => void;
}) {
  if (!isScdProperty(props.property)) {
    return null;
  }
  if (!props.property.scdOffset) {
    return null;
  }
  return <Offset value={props.property.scdOffset} onChange={offset => {
    props.onChange(_objectSpread(_objectSpread({}, props.property), {}, {
      scdOffset: offset
    }));
  }} data-sentry-element="Offset" data-sentry-component="SCDOffsetBlock" data-sentry-source-file="index.tsx" />;
}